import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { WaitlistTrayContext } from './context';
import { TrayContent } from './tray-content';

type Props = {
  closeModal: () => void;
};

export const WaitListTrayContent = ({ closeModal }: Props) => {
  const { t } = useTranslation('schedule-quick-fill');

  return (
    <WaitlistTrayContext.Provider value={{ closeModal }}>
      <Text size='medium' color='light' css={{ padding: theme.spacing(0, 6, 2, 3) }}>
        {t('Send waitlisted customers a direct booking link to fill last-minute cancellations fast')}
      </Text>
      <TrayContent />
    </WaitlistTrayContext.Provider>
  );
};
